import { localeReducer as locale } from 'react-localize-redux';
import { combineReducers } from 'redux-immutable';
// - Import reducers
import { authorizeReducer } from './authorize';
import { circleReducer } from './circles';
import { commentReducer } from './comments';
import { globalReducer } from './global';
import { imageGalleryReducer } from './imageGallery';
import { notificationReducer } from './notifications';
import { postReducer } from './posts';
import { userReducer } from './users';
import { voteReducer } from './votes';
import { serverReducer } from './server';
import { rendererReducer } from './renderers';
import { checkoutReducer } from './Checkout';
import { searchReducer } from './search';
import { modalReducer } from './Modal';
import { routerReducer } from 'react-router-redux';
// - Reducers
export var rootReducer = combineReducers({
    locale: locale,
    imageGallery: imageGalleryReducer,
    post: postReducer,
    circle: circleReducer,
    comment: commentReducer,
    vote: voteReducer,
    server: serverReducer,
    authorize: authorizeReducer,
    router: routerReducer,
    user: userReducer,
    notify: notificationReducer,
    global: globalReducer,
    renderer: rendererReducer,
    shoppingBag: checkoutReducer,
    OmniSearch: searchReducer,
    Modal: modalReducer
});



//////////////////
// WEBPACK FOOTER
// ./src/store/reducers/rootReducer.ts
// module id = 537
// module chunks = 50